/*
  assets/mad-quote-sheet.js (Worker S)
  The collection page "Price this door" sheet: one shared dialog per page, opened
  from any [data-mad-price-door] button (product object in data-mad-product).
  Three questions (rough opening, interior or exterior, door only or Install Ready),
  an honest fit readout, a live estimate, then /cart/add.js through MadSheetCore.
  Markup lives in snippets/mad-quote-sheet.liquid; hooks per docs/wizard-contract.md section 10.
*/
(function () {
  'use strict';
  if (window.MadSheet) return;

  var root, panel, form, state = { product: null, opener: null, open: false, soldOut: false };
  var REMEMBER_KEY = 'mad_sheet_answers';
  var core = function () { return window.MadSheetCore; };
  var E = function () { return window.MADEstimate; };
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  function setText(sel, text) { var el = $(sel); if (el) el.textContent = text; }
  function status(text, tone) { var el = $('[data-mad-status]'); if (!el) return; el.textContent = text || ''; if (tone) el.setAttribute('data-tone', tone); else el.removeAttribute('data-tone'); }
  function checked(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : ''; }
  function setChecked(name, value) { $$('input[name="' + name + '"]', form).forEach(function (i) { i.checked = i.value === value; }); }

  function answers() {
    var glass = form.querySelector('input[name="glass_compliance"]');
    return {
      intExt: checked('int_ext'),
      openingWidth: form.opening_width.value,
      openingHeight: form.opening_height.value,
      notMeasured: !!form.not_measured.checked,
      jambNeeded: checked('jamb_needed') || 'no',
      resize: checked('resize') || 'yes',
      glassCompliance: !!(glass && glass.checked),
    };
  }

  function needsGlassAck(p) {
    var c = core().ctxFor(p);
    return c.kind === 'antique' && c.flags.glass;
  }

  function remember(a) {
    try { sessionStorage.setItem(REMEMBER_KEY, JSON.stringify({ intExt: a.intExt, jambNeeded: a.jambNeeded })); } catch (e) { /* private mode */ }
  }
  function recall() {
    try { return JSON.parse(sessionStorage.getItem(REMEMBER_KEY) || '{}'); } catch (e) { return {}; }
  }

  /* ── fit readout wording (Worker S, three honest states) ────── */
  function fitSentence(fit) {
    var money = E().money(core().resizePrice());
    if (fit.state === 'unmeasured') return E().FIT_TEXT.unmeasured;
    if (fit.state === 'resize') return 'Needs resizing (+' + money + '). We review your measurements with you.';
    /* Seth 2026-10-11: no call here (one place to call, at the end of the request) */
    if (fit.state === 'talk' && fit.reason === 'arched_shorter') return 'This arched door cannot be shortened. We review your measurements with you.';
    if (fit.state === 'talk' && fit.reason === 'no_slab_size') return E().SIZE_TO_CONFIRM_TEXT; /* R04: no trusted size, no fit result */
    /* "we review your measurements with you", never a fit promise (brief, 2026-09-26); same states as before */
    if (fit.state === 'talk') return 'This opening needs a closer look. We review your measurements with you.';
    return E().FIT_TEXT.close;
  }

  /* ── live update ─────────────────────────────────────────────── */
  function update() {
    var p = state.product; if (!p) return;
    var a = answers();
    var fit = core().fitFor(p, a);
    var readout = $('[data-mad-fit-readout]');
    var hasInput = a.notMeasured || a.openingWidth.trim() || a.openingHeight.trim();
    var opening = !a.notMeasured && E().parseInches(a.openingWidth) && E().parseInches(a.openingHeight);
    if (readout) {
      readout.setAttribute('data-state', fit.state);
      readout.textContent = fitSentence(fit);
      readout.hidden = !(a.notMeasured || opening) || !hasInput;
    }
    var confirm = $('[data-mad-resize-confirm]');
    if (confirm) confirm.hidden = fit.state !== 'resize';
    setText('[data-mad-resize-price]', '+' + E().money(core().resizePrice()) + ', flat');
    setText('[data-mad-install-price]', '+' + E().money(core().installReadyPrice(p, a.intExt || 'interior')));
    var raw = core().quickRaw(p, Object.assign({}, a, { intExt: a.intExt || 'interior' }));
    var est = core().estimateFor(raw, p);
    setText('[data-mad-sheet-estimate]', E().money(est.total));
  }

  function validate(a) {
    if (!a.intExt) return { msg: 'Pick interior or exterior.', focus: 'input[name="int_ext"]' };
    if (!a.notMeasured) {
      var w = E().parseInches(a.openingWidth), h = E().parseInches(a.openingHeight);
      if (!w || !h) return { msg: 'Enter opening width and height in inches, or pick Not measured yet.', focus: !w ? 'input[name="opening_width"]' : 'input[name="opening_height"]' };
    }
    if (needsGlassAck(state.product) && !a.glassCompliance) {
      return { msg: 'Tick the glass safety acknowledgment to keep the original glass.', focus: 'input[name="glass_compliance"]' };
    }
    return null;
  }

  /* ── open / close ────────────────────────────────────────────── */
  function fillHeader(p) {
    var c = core().ctxFor(p);
    var code = E().doorLabel(p.title);
    /* the door's short name, as on its card (p.name, snippets/mad-card-name.liquid; polish, 2026-09-26); the code
       and size stay on the line under it. Display only: p.title stays the real title. */
    setText('[data-mad-sheet-title]', p.name || p.title || '');
    setText('[data-mad-sheet-slab]', (code && code !== p.title ? code + ' · ' : '') + (c.slab ? E().formatSlab(c.slab) + ' slab' : E().SIZE_TO_CONFIRM));
    setText('[data-mad-sheet-price]', E().money(c.doorPrice));
    setText('[data-mad-sheet-resize-code]', code || 'this door');
    var img = $('[data-mad-sheet-img]');
    if (img) { if (p.image) { img.src = p.image; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; } }
    var more = $('[data-mad-sheet-more]');
    if (more) more.href = (p.url || '#') + '#customize'; /* one address per door (2026-10-08); the door page opens the estimate */
    /* D3a and D8 wording from the price book (the Liquid default says the same) */
    var rule = $('[data-mad-rough-rule]'); if (rule) rule.textContent = E().roughOpeningText(window.MAD_PRICE_BOOK || {});
    /* collection page: no freight number (8/21 rule, no prices on collection pages) */
    var fn = $('[data-mad-sheet-foot] [data-mad-freight-note]'); if (fn) fn.textContent = E().freightText(1, window.MAD_PRICE_BOOK || {}, true, 'collection');
    var buyLabel = $('[data-mad-sheet-door-only-hint]');
    if (buyLabel) buyLabel.textContent = c.kind === 'handcrafted' ? 'Slab only' : 'Slab as shown';
    var glassAck = $('[data-mad-sheet-glass-ack]');
    if (glassAck) {
      glassAck.hidden = !needsGlassAck(p);
      var box = glassAck.querySelector('input[name="glass_compliance"]');
      if (box) box.checked = false;
    }
  }

  function resetForm() {
    form.reset();
    var r = recall();
    setChecked('int_ext', r.intExt || '');
    setChecked('jamb_needed', r.jambNeeded || 'no');
    setChecked('resize', 'yes');
    state.soldOut = false;
    var add = $('[data-mad-sheet-add]'); if (add) add.disabled = false;
    status('');
  }

  function showView(name) {
    var f = $('[data-mad-sheet-form]'), foot = $('[data-mad-sheet-foot]'), c = $('[data-mad-confirm]');
    if (f) f.hidden = name !== 'form';
    if (foot) foot.hidden = name !== 'form';
    if (c) c.hidden = name !== 'confirm';
  }

  function open(btn) {
    core().ready().then(function () {
      var p = core().productFromElement(btn);
      if (!p) { if (btn.href) window.location.href = btn.href; return; }
      state.product = p; state.opener = btn; state.open = true;
      fillHeader(p); resetForm(); showView('form'); update();
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mad-modal-open');
      /* QA Q-14: on a touch screen, focusing the width box pops the keyboard over the sheet before the
         shopper has seen it; focus the sheet's heading there (tabindex -1), the width box elsewhere. */
      var coarse = false;
      try { coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) { coarse = false; }
      var first = (coarse && $('[data-mad-sheet-title]')) || form.querySelector('input[name="opening_width"]');
      var focusFirst = function () { if (state.open && first && document.activeElement !== first) first.focus({ preventScroll: true }); };
      focusFirst();
      requestAnimationFrame(focusFirst);
      core().emit('mad:wizard:opened', { mode: 'sheet', product: p, lineKey: null });
    }).catch(function () { if (btn.href) window.location.href = btn.href; });
  }

  function close(reason) {
    if (!state.open) return;
    state.open = false;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mad-modal-open');
    core().emit('mad:wizard:closed', { mode: 'sheet', reason: reason || 'close' });
    var op = state.opener;
    if (op && document.contains(op)) op.focus({ preventScroll: true });
  }

  /* ── add ─────────────────────────────────────────────────────── */
  function onAdd() {
    var p = state.product; if (!p || state.soldOut) return;
    var a = answers();
    var bad = validate(a);
    if (bad) { status(bad.msg, 'error'); var f = form.querySelector(bad.focus); if (f) f.focus(); return; }
    var add = $('[data-mad-sheet-add]');
    add.disabled = true; status('Adding to your estimate...');
    var raw = core().quickRaw(p, a);
    core().addToCart(p, raw).then(function (res) {
      /* Add-to-cart tracking through window.madLead (snippets/mad-tracking.liquid; dry run on the preview). The old
         site had no collection card sheet; source 'sheet' sends the wizard's add to cart only while Theme settings >
         Tracking and search > "Count adds from the collection price sheet as add to cart" is on (on at launch, Seth,
         2026-09-25; docs/tracking.md 2). */
      try { if (window.madLead && typeof window.madLead.addToCart === 'function') window.madLead.addToCart({ id: String(p.variantId), name: p.title, value: Number(raw.estimate_total) || 0, source: 'sheet' }); } catch (e) { /* tracking never blocks the buyer */ }
      remember(a);
      var t = core().quoteTotals(res.cart);
      var code = E().doorLabel(p.title);
      var text = code + ' is on your estimate. ' + (t.count === 1 ? 'Estimate before freight ' : t.count + ' doors, estimate before freight ') + E().money(t.total) + '. ' + E().freightText(t.count, window.MAD_PRICE_BOOK || {}, false, 'collection');
      /* R03: a browser that is not keeping the estimate says so before Review estimate or any other page change */
      var list = window.MadEstimateList, limit = list && list.enabled && list.limitText ? list.limitText() : '';
      if (limit) text += ' ' + limit;
      /* Seth 2026-10-11 (no "Review with Magnolia"): this sheet asks three questions, so Install Ready leaves the frame
         details open; the next step is choosing them on the estimate (Add details), not the request form */
      var frame = raw.jamb_needed === 'yes';
      if (frame) text += ' Next, finish this door with Add details.';
      setText('[data-mad-confirm-text]', text);
      var finish = $('[data-mad-request-quote]'), review = $('[data-mad-review-link]');
      var cartUrl = (window.MadQuoteConfig && window.MadQuoteConfig.cartUrl) || (review && review.getAttribute('href')) || '/cart';
      if (finish) { finish.href = frame ? cartUrl : cartUrl + '#request-quote'; finish.textContent = frame ? 'Go to your estimate' : 'Request your quote'; }
      if (review) { review.href = cartUrl; if (review.parentNode) review.parentNode.hidden = frame; }
      showView('confirm');
      var cont = $('[data-mad-continue]'); if (cont) cont.focus();
    }).catch(function (err) {
      add.disabled = false;
      if (err && err.code === 'SOLD_OUT') {
        state.soldOut = true; add.disabled = true;
        status((E().doorLabel(p.title) || 'This door') + ' just sold. Call (337) 273-0189 and we will find a match.', 'error');
      } else {
        status((err && err.message) || 'Could not add. Try again or call (337) 273-0189.', 'error');
      }
    });
  }

  /* ── keyboard: focus trap and Escape (contract 12) ───────────── */
  function focusables() {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null && !el.closest('[hidden]'); });
  }
  function onKeydown(e) {
    if (!state.open) return;
    if (e.key === 'Escape') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables(); if (!list.length) return;
    var first = list[0], last = list[list.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || !panel.contains(active))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  /* ── viewport fallback when dvh is unsupported ───────────────── */
  function viewportFix() {
    var supportsDvh = window.CSS && CSS.supports && CSS.supports('height', '100dvh');
    if (supportsDvh || !window.visualViewport) return;
    var apply = function () { root.style.height = window.visualViewport.height + 'px'; };
    window.visualViewport.addEventListener('resize', apply); apply();
  }

  /* ── wiring ──────────────────────────────────────────────────── */
  function init() {
    root = document.getElementById('mad-sheet'); if (!root) return;
    panel = $('.mad-sheet__panel'); form = $('[data-mad-sheet-form]');
    if (!panel || !form) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-mad-price-door]') : null;
      if (!btn) return;
      e.preventDefault(); open(btn);
    });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-mad-sheet-close]');
      if (c) { e.preventDefault(); close(c.hasAttribute('data-mad-sheet-overlay') ? 'overlay' : c.hasAttribute('data-mad-continue') ? 'done' : 'close'); }
    });
    document.addEventListener('keydown', onKeydown); /* on document so Escape and Tab work even if focus slipped outside */
    form.addEventListener('input', function (e) {
      if (e.target.name === 'opening_width' || e.target.name === 'opening_height') { if (e.target.value.trim()) form.not_measured.checked = false; }
      update();
    });
    form.addEventListener('change', function (e) {
      if (e.target.name === 'not_measured' && e.target.checked) { form.opening_width.value = ''; form.opening_height.value = ''; }
      status(''); update();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); onAdd(); });
    var add = $('[data-mad-sheet-add]'); if (add) add.addEventListener('click', onAdd);
    viewportFix();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.MadSheet = { open: open, close: close, isOpen: function () { return state.open; }, answers: function () { return form ? answers() : null; } };
})();
